import template from './addToCartWithContract.html';
import _ from 'lodash';

class AddToCartWithContractController {
    /*@ngInject*/
    constructor($window, $scope, alertService, userService, $uibModal, constants, dataContext, catalogService, $rootScope, cartService) {
        this.$window = $window;
        this.$scope = $scope;
        this.alertService = alertService;
        this.userService = userService;
        this.$uibModal = $uibModal;
        this.constants = constants;
        this.dataContext = dataContext;
        this.catalogService = catalogService;
        this.$rootScope = $rootScope;
        this.cartService = cartService;

        this.isProductEligibleForDeal = false;
    }

    $onInit() {
        if (!_.isNumber(this.quantity)) {
            this.quantity = 1;
        }

        this.productIds = [this.productId];
        if (!_.isNil(this.groupedProductIds)) {
            this.productIds = this.groupedProductIds;
        }

        return this.dataContext.configurations.getAll().then(config => {
            if (config.freeRadioCouponId) {
                return this.catalogService.getProduct(this.productIds).then(products => {
                    this.properties = _.flatten(products.data.map(d => d.properties));
                    this.products = products.data;

                    if (this.products && this.products[0].sku === this.constants.skus.verizonLteRadio) {
                        this.isPurchaseValidForPanel();
                    }
                });
            }

            return null;
        });
    }

    goToCart() {
        this.addProductsToCart().finally(() => this.$window.location.href = this.constants.cartHref);
    }

    addProductsToCart() {
        this.isLoading = true;
        const settings = [{
            Name: this.constants.radioDeal.couponCode,
            Value: 'True'
        }];

        return this.dataContext.settings.updateUserSettings(settings).then(() => {
            this.$rootScope.$emit(this.constants.updatingCart, ['true']);
            if (_.isNil(this.quantity)) {
                this.quantity = 1;
            }

            // This offerId check is a holdover from the addToCart component, unclear if it's necessary:
            //      Check if there is an OfferId on the Query String - this is the upsell flag
            var offerId = '0';
            if (!_.isNil(this._getQueryStringValue('offer_id'))) {
                offerId = this._getQueryStringValue('offer_id');
            }

            return this.cartService.addLineItems(this.config.productIds, this.quantity, offerId).then(() => {
                this.$rootScope.$emit(this.constants.updatingCart, ['false']);
            });
        }).then(() => {
            return this.cartService.addCoupon(this.constants.radioDeal.couponCode, 0, 0)
                .then(() => {
                    this.$rootScope.$broadcast('cartItemsChanged');
                });
        });
    }

    continueShopping() {
        this.addProductsToCart().finally(() => this.$close());
    }

    _getQueryStringValue(key) {
        return decodeURIComponent(this.$window.location.search.replace(new RegExp('^(?:.*[&\\?]' + encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));
    }

    openContractModal() {
        let modalInstance = this.$uibModal.open({
            template: '<fp-docusign-contract-modal config="config"></fp-docusign-contract-modal>',
            size: 'lg',
            backdrop: 'static',
            controller: ($scope) => {
                'ngInject';
                $scope.config = {
                    productIds: this.productIds,
                    close: modalInstance.close,
                    dismiss: modalInstance.dismiss,
                    title: 'FREE RADIO WITH A 1 YEAR CONTRACT',
                    shouldShowConfirmButtonOne: true,
                    shouldShowConfirmButtonTwo: true,
                    confirmButtonOneText: 'Go to Cart',
                    confirmButtonTwoText: 'Continue Shopping'
                };
                $scope.config = {
                    close: modalInstance.close,
                    dismiss: modalInstance.dismiss,
                    title: 'FREE RADIO WITH A 1 YEAR CONTRACT',
                    confirmButtonOne: {
                        text: 'Go to Cart',
                        shouldShow: true,
                        action: this.goToCart
                    },
                    confirmButtonTwo: {
                        text: 'Continue Shopping',
                        shouldShow: true,
                        action: this.continueShopping
                    }
                };
            }
        });
    }

    isPurchaseValidForPanel() {
        const listOfXtSpecificProducts = [this.constants.skus.verizonLteRadio];
        return this.dataContext.panel.getVersion().then(response => {
            const panelType = response.PanelType;

            const xtSpecific = _.filter(listOfXtSpecificProducts, o => this.products.map(p => p.sku).includes(o))
                .length;

            var hasXt = _.some(this.constants.panelType.simonXT, (pt) => { return pt.toLowerCase() === panelType.toLowerCase(); });
            if (xtSpecific > 0 && !hasXt) {
                this.isProductEligibleForDeal = false;
            } else {
                this.isProductEligibleForDeal = true;
            }
        });
    }
}

export default {
    template: template,
    bindings: {
        productId: '<',
        quantity: '=',
        max: '<',
        price: '<',
        imageUrl: '<',
        name: '<',
        sku: '<',
        isBuyable: '<',
        properties: '<',
        groupedProductIds: '<'
    },
    controller: AddToCartWithContractController
};